export const INTRO_ROUTE = '/intro';

export const ORDERS_ROUTE = '/orders';
export const FINANCIAL_CLOSURE_ROUTE = '/financial-closure';
export const FILTER_LABELS_ROUTE = '/filter-labels';
export const INGREDIENTS_ROUTE = '/ingredients';
export const FOODS_AND_PRODUCTS_ROUTE = '/foods';
export const MENU_ROUTE = '/menu';
export const AUTH_ROUTE = '/auth';
export const OFFERS_ROUTE = '/offers';
export const USER_ROUTE = '/user';
export const REFRESH_ROUTE = '/refresh';
